/* 🤖 this file was generated by svg-to-ts */
export const matIconStackedBarChart: {
  name: 'stacked-bar-chart';
  data: string;
} = {
  name: 'stacked-bar-chart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 9h4v11H4zm0-5h4v4H4zm6 3h4v4h-4zm6 3h4v4h-4zm0 5h4v5h-4zm-6-3h4v8h-4z"/></svg>`
};
